import {command, queryOne, queryPage} from "../utils/api";

const USER_BASE_URL = `${process.env.PUBLIC_URL}/api/v1/user`;

const USER_CHANGE_PASSWORD_URL = `${USER_BASE_URL}/changePassword`;
export const USER_CHANGE_PASSWORD = 'USER_CHANGE_PASSWORD';
export const USER_CHANGE_PASSWORD_COMPLETED = 'USER_CHANGE_PASSWORD_COMPLETED';
export const USER_CHANGE_PASSWORD_FAILED = 'USER_CHANGE_PASSWORD_FAILED';
export const changePassword = command(USER_CHANGE_PASSWORD_URL, USER_CHANGE_PASSWORD, USER_CHANGE_PASSWORD_COMPLETED,
  USER_CHANGE_PASSWORD_FAILED);

const USER_ADD_USER_URL = `${USER_BASE_URL}/add`;
export const USER_ADD_USER = 'USER_ADD_USER';
export const USER_ADD_USER_COMPLETED = 'USER_ADD_USER_COMPLETED';
export const USER_ADD_USER_FAILED = 'USER_ADD_USER_FAILED';
export const addUser = command(USER_ADD_USER_URL, USER_ADD_USER, USER_ADD_USER_COMPLETED, USER_ADD_USER_FAILED);

const USER_UPDATE_USER_URL = `${USER_BASE_URL}/update`;
export const USER_UPDATE_USER = 'USER_UPDATE_USER';
export const USER_UPDATE_USER_COMPLETED = 'USER_UPDATE_USER_COMPLETED';
export const USER_UPDATE_USER_FAILED = 'USER_UPDATE_USER_FAILED';
export const updateUser = command(USER_UPDATE_USER_URL, USER_UPDATE_USER, USER_UPDATE_USER_COMPLETED, USER_UPDATE_USER_FAILED);

const USER_GET_USERS_URL = `${process.env.PUBLIC_URL}/api/v1/r/userList`;
export const USER_GET_USERS = 'USER_GET_USERS';
export const USER_GET_USERS_COMPLETED = 'USER_GET_USERS_COMPLETED';
export const USER_GET_USERS_FAILED = 'USER_GET_USERS_FAILED';
export function getUsers(pagination) {
  return queryPage(USER_GET_USERS_URL, {}, USER_GET_USERS, USER_GET_USERS_COMPLETED, USER_GET_USERS_FAILED, pagination);
}

const USER_GET_USER_URL = `${process.env.PUBLIC_URL}/api/v1/r/userList`;
export const USER_GET_USER = 'USER_GET_USER';
export const USER_GET_USER_COMPLETED = 'USER_GET_USER_COMPLETED';
export const USER_GET_USER_FAILED = 'USER_GET_USER_FAILED';
export function getUser({userId}) {
  return queryOne(USER_GET_USER_URL, {where:{userId}}, USER_GET_USER, USER_GET_USER_COMPLETED, USER_GET_USER_FAILED);
}



// WEBPACK FOOTER //
// ./src/User/actions.js